import logger from '@logger'

export function renderValue({ value, options = {}, conventions = {} }) {
  if (value === null || value === undefined) return ''

  const numericValue = Number(value)
  if (Number.isNaN(numericValue)) return ''

  const number = conventions?.number ?? {}
  const currencyConfig = conventions?.currencyConfig ?? {}
  const currency = conventions?.currency

  const {
    prefix = '',
    postfix = '',
    spaceBetween = true,
    precisionType = 'output', // output | balance
    minimumFractionDigits,
    maximumFractionDigits,
  } = options

  // determine precision rules
  const precision =
    precisionType === 'balance'
      ? currencyConfig.balanceOutputPrecision
      : currencyConfig.outputPrecision

  const minDigits = minimumFractionDigits ?? precision?.min

  const maxDigits = maximumFractionDigits ?? precision?.max

  let formatted

  try {
    const locale = number.locale ?? 'en-US'
    const resolvedStyle = number.style ?? 'decimal'
    const canUseCurrencyStyle = resolvedStyle === 'currency' && !!currency

    const formatterOptions = {
      style: canUseCurrencyStyle ? 'currency' : 'decimal',
      useGrouping: number.useGrouping ?? true,
      notation: number.notation ?? 'standard',
      signDisplay: number.signDisplay ?? 'auto',
    }

    if (canUseCurrencyStyle) {
      formatterOptions.currency = currency
      formatterOptions.currencyDisplay = number.currencyDisplay ?? 'symbol'
    }

    if (minDigits !== undefined) {
      formatterOptions.minimumFractionDigits = minDigits
    }

    if (maxDigits !== undefined) {
      formatterOptions.maximumFractionDigits = maxDigits
    }

    formatted = new Intl.NumberFormat(locale, formatterOptions).format(numericValue)
  } catch (error) {
    formatted = numericValue.toString()
    logger.error('Error formatting value:', error)
  }

  const space = spaceBetween ? ' ' : ''

  return `${prefix}${prefix ? space : ''}${formatted}${postfix ? space : ''}${postfix}`.trim()
}
